import {html} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {styles} from './brand.styles';
import {LitElementStateful} from '@stefanholzapfel/lit-state';
import {State} from '../../loading/loading';

@customElement('lit-brand')
export class Brand extends LitElementStateful<State> {
    @property({type: String})
    public currentRoute: string;

    static get styles() {
        return [
            styles
        ];
    }

    protected render() {
        return html`
            <div class="logo"></div>
            <div class="brand-text"></div>
        `;
    }
}
